import React, {Component} from 'react';

import {connect} from 'react-redux'
// import 'react-select/dist/react-select.css';
import {locale} from '../locale/AppLocale';
import {Link} from 'react-router-dom'
import Loader from '../Components/Loader';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ShooqModal from '../Components/ShooqModal';
import * as productFindActions from '../actions/productFindActions'
import {GetEntityAttribute} from "../Helpers/Entity";

class ListingProducts extends Component {
    constructor(props) {
        super(props);

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        this.props.resetModalProduct();
    }

    showModal(productId) {
        this.props.findProduct(productId);
    }

    closeModal(proxy) {
        this.props.resetModalProduct();
    }

    renderModalContent() {
        if (!this.props.modalProduct.fetched) {
            return '';
        }

        let product = this.props.modalProduct.product;
        return (
            <div>
                <div className="product-details">
                    {
                        this.props.modalProduct.product.images.length > 0 ? (
                                <div className="product-details--gallery">
                                    <ImageGallery
                                        thumbnailPosition={'bottom'}
                                        items={this.getProductImages()}
                                        slideInterval={2000}
                                        showPlayButton={false}
                                    />
                                </div>

                            ) : ('')
                    }
                    {
                        product.attributes.length > 0 ? (
                                <div
                                    className={`product-details--attributes ` + (this.props.modalProduct.product.images.length === 0 ? ' no-gallery ' : '') }>
                                    <ul className="product-details--props">
                                        {product.attributes[0] && product.attributes[0].attributes.map((property, index) => {
                                            if (index < 10) {
                                                return (
                                                    <li key={index}>
                                                        <span className="product-details--prop-name">{GetEntityAttribute(property,'title')}: </span>
                                                        <span
                                                            className="product-details--prop-value">{GetEntityAttribute(property,'value_text')}</span>
                                                    </li>
                                                );
                                            }
                                            return null;
                                        })}
                                    </ul>
                                </div>
                            ) : ('')
                    }
                </div>
                <div className="clearfix"></div>
                <div className="mt-30">
                    {product.attributes[0] && product.attributes.map((propertyGroup, index) => {
                        let className = 'table ';
                        if (index > 0) {
                            className += ' mt-30 ';
                        }

                        return (
                            propertyGroup.attributes && propertyGroup.attributes.length > 0 && <div key={index}>
                                <table className={className} width="100%">
                                    <thead>
                                    <tr>
                                        <td colSpan="2" className="table--head">{propertyGroup.name}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {  propertyGroup.attributes.map((property, index) => {
                                        return (
                                            <tr key={index}>
                                                <th className="bg-white" width="50%">{GetEntityAttribute(property,'title')}</th>
                                                <td className="bg-white" width="50%">{GetEntityAttribute(property,'value_text')}</td>
                                            </tr>
                                        );
                                    })
                                    }
                                    </tbody>
                                </table>
                                <div className="clearfix"></div>
                            </div>
                        );
                    })
                    }

                </div>
                {
                    (product.description_ar && product.description_ar.length > 0) ? (
                            <div>
                                <table className='table mt-30' width="100%">
                                    <thead>
                                    <tr>
                                        <td className="table--head">{locale.get('product_details')}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="bg-white no-hover"
                                            dangerouslySetInnerHTML={this.createMarkup(product.description_ar)}/>
                                    </tr>

                                    </tbody>
                                </table>
                                <div className="clearfix"></div>
                            </div>
                        ) : ('')
                }

                <div className="clearfix"></div>
                <div className="mt-30">
                    <Link className="btn-1 btn--block"
                          to={`/${this.props.match.params.businessSlug}/sell/` + this.props.modalProduct.product.id}>{  locale.get('sell_this_product') }</Link>
                </div>
            </div>
        );
    }

    createMarkup(string) {
        return {__html: string};
    }

    getProductImages() {
        let images = [];
        this.props.modalProduct.product.images.forEach((img, index) => {
            images.push({original: img.full, thumbnail: img.thumb});
        });
        return images;
    }

    renderNewProductTemplate(index) {

        if (!this.canRenderTemplatePosition(index)) {
            return;
        }

        return (
            <div className="products-list--item">
                <div className="panel-1--body">
                    <div className="text-center">
                        <p><strong>{locale.get('did_not_you_found_your_product')}</strong></p>
                        {
                            (this.props.category.alias_to && this.props.category.alias_to > 0) ? (
                                    <Link className="btn-3"
                                          to={`/${this.props.match.params.businessSlug}/create/` + this.props.category.alias_to}>{locale.get('add_new_product_now_if_not_exists')}</Link>
                                ) : (
                                    <Link className="btn-3"
                                          to={`/${this.props.match.params.businessSlug}/create/` + this.props.category.id}>{locale.get('add_new_product_now_if_not_exists')}</Link>
                                )
                        }
                    </div>
                </div>
            </div>
        )
    }

    canRenderTemplatePosition(index) {
        if (index === 0){
            return true;
        }
        if (this.props.products.length > 20 && (index % 20 === 0)) {
            return true;
        }else if (this.props.products.length < 20 && ( (index+1) >= this.props.products.length  )) {
            return true;
        }
        return false;
    }

    renderProductList() {
        return (
            <div className="products-list">

                {this.props.products.length === 0 ? (<div className="panel-1--body mt-10">
                        {this.renderNewProductTemplate(0)}
                        <div className="alert alert--warning text-center">{locale.get('no_products_found')}</div>
                    </div>) : (
                        this.props.products.map((product, index) => {
                            return (
                                <div key={index}>
                                    {this.renderNewProductTemplate(index)}
                                    <div className="products-list--item">

                                        {
                                            product.image.length > 0 ? (
                                                    <div className="products-list--image">
                                                        <img onClick={ () => {
                                                            this.showModal(product.id)
                                                        } } src={product.image} alt=""/>
                                                    </div>
                                                ) : (
                                                    ''
                                                )
                                        }

                                        <div
                                            className={`products-list--specs ` + (product.image.length === 0 ? 'no-image' : '')}>
                                            <Link className="products-list--title"
                                                  onClick={ (e) => {
                                                      e.preventDefault();
                                                      this.showModal(product.id);
                                                  } }
                                                  to={`/${this.props.match.params.businessSlug}/sell/` + product.id}>{GetEntityAttribute(product,'title')}</Link>
                                            {
                                                product.attributes.length > 0 ? (
                                                        <div className="products-list--props">
                                                            {product.attributes[0].attributes.map((property, index) => {
                                                                return (
                                                                    <div className="products-list--prop" key={index}>
                                                                        <strong
                                                                            className="products-list--prop-name">{GetEntityAttribute(property,'title')}: </strong>
                                                                        <span
                                                                            className="products-list--prop-value">{property.value_text}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                    ) : ('')
                                            }
                                            <Link className="products-list--sell btn-1"
                                                  to={`/${this.props.match.params.businessSlug}/sell/` + product.id}>{  locale.get('sell_this_product') }</Link>
                                        </div>
                                    </div>

                                    {/*{this.renderNewProductTemplate(index)}*/}

                                </div>
                            )
                        })
                    )}
            </div>
        )
    }

    render() {
        return (
            <div>
                {
                    (this.props.modalProduct.fetchingProduct) ? (
                            <ShooqModal showModal={true} onRequestClose={this.closeModal}
                                         modalTitle={GetEntityAttribute(this.props.modalProduct.product,'title')}
                                         modalSubTitle={GetEntityAttribute(this.props.modalProduct.product,'category_title')}>
                                <Loader completed={this.props.modalProduct.fetched}>
                                    {this.renderModalContent()}
                                </Loader>
                            </ShooqModal>
                        ) : ('')
                }
                {this.renderProductList()}
            </div>
        );
    }

}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        modalProduct: state.findProduct,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        findProduct: (productId) => dispatch(productFindActions.findProduct(productId)),
        resetModalProduct: () => dispatch(productFindActions.resetFetchedProduct()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingProducts);